import React, { memo } from "react";
import { HeaderWrapper, SubTitleText, TitleText } from "./styles";
import { isEmpty } from "@swiggy-private/js-utils";

export interface IHeader {
    title: string;
    subTitle?: string;
    isDisabled?: boolean;
}

const Header = ({ title, subTitle, isDisabled }: IHeader) => {
    return (
        <HeaderWrapper>
            <TitleText variant="V2.subheading1.neutral.medium" isDisabled={isDisabled}>
                {title}
            </TitleText>
            {!isEmpty(subTitle) && (
                <SubTitleText variant="V2.body3.neutral.regular" isDisabled={isDisabled}>
                    {subTitle}
                </SubTitleText>
            )}
        </HeaderWrapper>
    );
};

export default memo(Header);
